module.exports = __webpack_public_path__ + "media/images/recruit/mv/img-mark-05-d30aed2a1f7793bb5cdd7b64a30f88ad.svg";